import type { CampLocation } from "@/types/campLocation";

/** Stable alphabetical sort by `name` (case-insensitive), for dropdowns and lists. */
export function sortCampLocationsByName(locations: CampLocation[]): CampLocation[] {
  return [...locations].sort((a, b) =>
    (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" })
  );
}
